import { ActionIcon } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

import { useDeleteSpeaker } from "../../api/speakers";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";

export default function DeleteSpeakerModal({ speakerId }) {
  const { mutate } = useDeleteSpeaker();
  const confirmDelete = useDeleteConfirm("speaker", mutate);

  return (
    <ActionIcon
      onClick={() => confirmDelete({ id: speakerId })}
      aria-label="Delete speaker"
      color="red"
      variant="light"
    >
      <IconTrash />
    </ActionIcon>
  );
}
